import { render, staticRenderFns } from "./ActualCosts.vue?vue&type=template&id=63d0942a&scoped=true"
import script from "./ActualCosts.vue?vue&type=script&lang=js"
export * from "./ActualCosts.vue?vue&type=script&lang=js"
import style0 from "./ActualCosts.vue?vue&type=style&index=0&id=63d0942a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d0942a",
  null
  
)

export default component.exports